import React from "react";
import { Icon } from "@iconify/react";

const LoadingMessage = ({ message }) => {
  return (
    <div className="flex items-center gap-1">
      <Icon className="animate-spin" icon="tabler:loader-2" />
      <span>{message}</span>
    </div>
  );
};

export default LoadingMessage;
